import enGb from './locales/en-gb.json';
import enUs from './locales/en-us.json';
import enKe from './locales/en-ke.json';
import enNz from './locales/en-nz.json';
import thTh from './locales/th-th.json';
import swKe from './locales/sw-ke.json';
import esMx from './locales/es-mx.json';

export default {
  'en-gb': enGb,
  'en-us': enUs,
  'en-ke': enKe,
  'en-nz': enNz,
  'th-th': thTh,
  'sw-ke': swKe,
  'es-mx': esMx,
};
